var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7806 2.45385C17.7126 1.67385 17.124 1.06 16.3543 1L5.43286 1.00923C5.01176 1.05538 4.74914 1.25846 4.45029 1.54C3.38623 2.56462 2.42177 3.71846 1.34412 4.73846C1.14037 4.99692 1.01358 5.30615 1 5.63846V19.0462C1.05886 19.8308 1.66108 20.4354 2.4263 20.5H16.3588C17.1104 20.4354 17.7126 19.8446 17.7851 19.0785V2.45385H17.7806ZM6.04413 1.83077H13.7914V3.13231C13.7914 3.13231 13.7235 3.21077 13.7145 3.21077H6.08941C6.08941 3.21077 6.04413 3.16923 6.04413 3.16462V1.83538V1.83077ZM14.7468 19.6738H4.06089V10.7662H14.7468V19.6738ZM17.0018 18.8615C16.9836 19.1338 16.8976 19.4015 16.6622 19.5538C16.3226 19.7708 15.906 19.66 15.5302 19.6692V10.2262C15.5302 10.1338 15.2947 9.92615 15.1861 9.93538L3.52207 9.94923C3.44509 9.97231 3.25492 10.1477 3.25492 10.2262V19.6692H2.34027C2.34027 19.6692 2.11387 19.5492 2.08671 19.5308C1.87842 19.3738 1.80145 19.1108 1.78333 18.8615V5.82308C1.79692 5.58769 1.83314 5.41692 1.97804 5.22769L5.1476 2.02923L5.23816 1.98308V3.31231C5.23816 3.62615 5.71812 4.04615 6.03055 4.03231H13.8096C14.0858 4.04615 14.5748 3.60308 14.5748 3.34462V1.83077H16.4493C16.4493 1.83077 16.6712 1.94615 16.7029 1.96923C16.9112 2.13077 16.9882 2.38 17.0063 2.63846V18.8615H17.0018Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.32933 17.1307H12.4556C12.4556 17.1307 12.5009 17.0892 12.5009 17.0846V16.3046H6.28857V17.0846C6.28857 17.0846 6.32933 17.1307 6.33385 17.1307H6.32933Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4965 13.3369H6.28418V14.1308H12.4965V13.3369Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.ec1719098b0c8fee2be5e3982616a812.svg";
export { ForwardRef as ReactComponent };